import { store } from "reduxStore/store";
import moment from "moment-timezone";
import { formatDateUnixMS } from "./dateUtils";
import { isNullOrUndefined } from "./objectUtils";
import {
  formatBytes,
  formatGB,
  formatMB,
  formatNumber,
  formatPercentage,
  formatTime,
} from "utils/numberUtils";
import { TABLE_FORMAT_FULL } from "Consts";

export const renderMB = (val) => {
  if (isNullOrUndefined(val)) return null;
  return `${formatMB(val)}`;
};

export const renderPercentage = (val: any) => {
  const p = formatPercentage(val, 0, null);
  return Number.isNaN(p) ? null : p;
};

export const renderGB = (val) => {
  if (isNullOrUndefined(val)) return null;
  const g = formatGB(val);
  return `${Number.isNaN(g) ? null : g}`;
};
export const renderNumeric = (val: string | number) => {
  return formatNumber(val); // todo: support col.decimalPoints
};

export const renderAvailability = (val: any) => {
  return `${formatPercentage(val, 3, null)}`;
};
export const renderRoundNumeric = (val) => {
  return formatNumber(val, 0); // todo: support col.decimalPoints
};

export const renderBytes = (val) => {
  if (isNullOrUndefined(val)) return null;
  return `${formatBytes(val)}`;
};

export const renderDate = (stringDate) => {
  if (isNullOrUndefined(stringDate)) {
    return null;
  }

  return moment(stringDate).format(TABLE_FORMAT_FULL);
};

export const renderShortDate = (stringDate) => {
  if (isNullOrUndefined(stringDate)) {
    return null;
  }

  return moment(stringDate).format("MMM D, HH:mm");
};

export const renderTime = (ms) => formatTime(ms);

export const renderUnixTS = (unix) => {
  const state: any = store.getState();
  return formatDateUnixMS(unix, state.auth.currentUser);
};

export const renderBoolText = (val: any) => {
  if (val) {
    return "Yes";
  } else {
    return "No";
  }
};

export const filterDataBySearchText = (
  data: any[],
  searchTerm: string,
  searchTextInFields?: string[]
) => {
  return data?.filter((row) => {
    if (!searchTerm || searchTerm?.length === 0) {
      return true;
    }

    const lower = searchTerm.toLowerCase();
    if (searchTextInFields) {
      return searchTextInFields.some((field) => {
        const v = row[field];
        return `${v}`.toLowerCase().includes(lower); //contains
      });
    } else {
      return Object.values(row).some((v) => `${v}`.toLowerCase().includes(lower)); //contains
    }
  });
};

type Dataset = {
  context: string;
  columns: any[];
  data: any[];
};

export const wisdomAdvisorTableMapper = (dataset: Dataset) => {
  const columns = dataset?.columns?.map((col) =>
    typeof col.name === "string" ? `${col.name} - ${col.field}` : `${col.field}`
  );

  const data = dataset?.data?.map((row) =>
    dataset?.columns?.map((col) => {
      const value = row[col.field] ?? "";
      return Array.isArray(value) ? `${value.join(";")}` : `${value}`;
    })
  );

  return {
    context: dataset.context,
    columns,
    data,
  };
};

export const toUseCase = (str: string | null): string => {
  const _path = window.location.pathname.replaceAll("/", "_");
  if (typeof str !== "string") return _path;
  return (
    str
      .trim() // remove leading/trailing spaces
      .toLowerCase() // lowercase everything
      .replace(/\s+/g, "_") // replace spaces/tabs/newlines with _
      .replace(/[^\w_]/g, "") + _path
  ); // remove non-word chars except _
};
